import React from 'react';
import {
  AppstoreAddOutlined,
  CarryOutOutlined,
  DashboardOutlined,
  DollarOutlined,
  ExportOutlined,
  HistoryOutlined,
  ProfileOutlined,
  SafetyCertificateOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { useHandleClick } from '@/components/UserOptions/hooks';
import { USER_ACTION_TYPE } from '@/components/UserOptions/constants';

/**
 * Navigation define all the routes and link that
 * will be render in the sidebar or navbar(depending of the layout)
 *
 * It can be an
 * {Array} Use array when yo have group sections, like Main, Admin , etc
 * Ex: [{title:'name', menu:[...],}, ....]
 *
 * {Object} Use object when yo don't have section , it is just one,
 * Ex: {menu: [.....]}
 * */
export const navigation = [
  {
    title: '',
    menu: [
      {
        title: 'dashboard',
        icon: <DashboardOutlined />,
        link: '/'
      },
      {
        title: 'clientCodes',
        onlyUser: true,
        icon: <ProfileOutlined />,
        link: '/clientCodes',
      },
      {
        title: 'payments',
        onlyUser: true,
        icon: <DollarOutlined />,
        link: '/payments/payments',
      },
      {
        onlyUser: true,
        paymentActive: true,
        icon: <HistoryOutlined />,
        link: '/payments/payment-record',
      },
    ],
  },
  {
    title: 'admin',
    permissions: [
      'FAQ:READ',
      'CONTRACT_REQUEST:SEARCH',
      'CONTRACT_REQUEST:READ',
      'PROCESS_STATE:WRITE',
      'PROCESS_BIGCLIENT:WRITE',
      'PROCESS_RESIDENTIAL:WRITE',
      'TRACE:READ',
      'COMMERCIAL_OFFICE:READ',
      'COMMERCIAL_OFFICE:WRITE',
      'ADMIN',
      'FAQ:WRITE',
    ],
    menu: [
      {
        paymentActive: true,
        icon: <HistoryOutlined />,
        link: '/payments/payment-record',
        permissions: ['ADMIN', 'INVOICE:READ'],
      },
      {
        title: 'contractRequest',
        icon: <CarryOutOutlined />,
        path: '/contractrequest',
        menu: [
          {
            title: 'contractRequestStateAdmins',
            link: '/contract-request-state-admins',
            permissions: ['CONTRACT_REQUEST:SEARCH', 'CONTRACT_REQUEST:WRITE', 'PROCESS_STATE:WRITE'],
          },
          {
            title: 'contractRequestBigClientMenu',
            link: '/contract-request-big-client-admins',
            permissions: ['CONTRACT_REQUEST:SEARCH', 'CONTRACT_REQUEST:WRITE', 'PROCESS_BIGCLIENT:WRITE'],
          },
          {
            title: 'contractRequestResidentialClient',
            link: '/contract-request-residential-admins',
            permissions: ['CONTRACT_REQUEST:SEARCH', 'CONTRACT_REQUEST:WRITE', 'PROCESS_RESIDENTIAL:WRITE'],
          },
        ],
      },
      {
        title: 'security',
        path: '/admin',
        icon: <SafetyCertificateOutlined />,
        permissions: ['USER:WRITE', 'ROLE:WRITE', 'TRACE:READ'],
        menu: [
          {
            link: '/users',
            permissions: ['USER:WRITE'],
          },
          {
            link: '/permissions',
            permissions: ['ROLE:WRITE'],
          },
          {
            link: '/traces',
            permissions: ['TRACE:READ'],
          },
        ],
      },
      {
        title: 'nomenclators',
        icon: <AppstoreAddOutlined />,
        permissions: ['COMMERCIAL_OFFICE:READ', 'FAQ:READ', 'COMMERCIAL_OFFICE:WRITE', 'FAQ:WRITE'],
        menu: [
          {
            link: '/nomenclators/commercial-offices',
            permissions: ['COMMERCIAL_OFFICE:READ', 'COMMERCIAL_OFFICE:WRITE'],
          },
          {
            title: 'faqs',
            link: '/faqs/configuration',
            permissions: ['FAQ:WRITE'],
          },
        ],
      },
    ],
  },
];

export const userOptions = {
  userActions: {
    viewType: USER_ACTION_TYPE.POPUP,
    showInfo: true,
    options: [
      {
        divider: true,
      },
      {
        title: 'profile',
        action: 'PROFILE',
        icon: <UserOutlined />,
      },
      {
        divider: true,
      },
      {
        title: 'logout',
        action: 'LOGOUT',
        icon: <ExportOutlined />,
      },
    ],
  },
  useHandleClick,
};
